var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group has-float-label"},[_c('vue-tel-input',{attrs:{"type":"tel","value":_vm.defaultInput,"preferredCountries":['IN']},on:{"keypress":function($event){return _vm.isNumber($event)},"input":(e) => _vm.$emit('input', e),"validate":_vm.isValidate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }